module.exports = __webpack_public_path__ + "static/media/infoSign.6416ac19.png";